export default "__VITE_ASSET__KUYFFO9n__"